var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.access.report_sale_by_payment)?_c('v-reports',{attrs:{"headers":_vm.headers,"update":_vm.update,"data":_vm.data,"numPages":_vm.numPages,"data_loading":_vm.data_loading,"Payment":""},on:{"change-pagination":_vm.changePagination}}):_c('error404')
}
var staticRenderFns = []

export { render, staticRenderFns }